// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1YHG_","item":"PaymentsMobile_item__16N1E","label":"PaymentsMobile_label__i8Vcw","amount":"PaymentsMobile_amount__2OODu"};